import { useToast } from '@/state/toastStore';
import { useT } from '@/i18n/useT';

/**
 * Bottom-centre status line with an optional action. `role="status"` so the
 * message is announced without stealing focus — an undo offer must never
 * interrupt someone mid-list, so it is polite, not assertive.
 */
export function Toast() {
  const { t } = useT();
  const toast = useToast((s) => s.toast);
  const dismiss = useToast((s) => s.dismiss);

  return (
    <div
      role="status"
      aria-live="polite"
      className="pointer-events-none fixed inset-x-0 bottom-4 z-50 flex justify-center px-2"
    >
      {toast ? (
        <div
          key={toast.id}
          className="pointer-events-auto flex items-center gap-3 rounded-sm border border-pip-dim bg-surface-2 px-3 py-1.5 text-[12px] leading-4 text-text shadow-md shadow-black/50"
        >
          <span>{toast.message}</span>
          {toast.action ? (
            <button
              type="button"
              onClick={() => {
                toast.action?.run();
                dismiss();
              }}
              className="rounded-xs border border-pip-dim px-2 py-0.5 font-display text-[11px] leading-4 font-bold text-pip uppercase hover:bg-pip-faint/40"
            >
              {toast.action.label}
            </button>
          ) : null}
          <button
            type="button"
            onClick={dismiss}
            aria-label={t('common.close')}
            className="text-text-faint hover:text-pip"
          >
            ✕
          </button>
        </div>
      ) : null}
    </div>
  );
}
